import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.3.6_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@22.19.17_babel-plug_ff1721579fdc4d7cade00194e16030ac/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/builder/clientUtils.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StatsigExperimentContextProvider"] */ "/app/packages/statsig/src/StatsigExperimentContext.tsx");
